

<div class="mt-3" style="border-bottom: 1px solid #CCC">

    <ul class="nav nav-tabs" *ngIf="activeCostGroup">
        <li
            *ngFor="let costGroup of costGroups; let cg = index"
            class="nav-item"
            (click)="setCostGroup(cg)">
            <a
                [ngClass]="{'active' : activeCostGroup.id === costGroup.id}"
                class="nav-link">{{costGroup.name}}</a>
        </li>
    </ul>
    <div class="row mt-3" *ngIf="activeCostGroup && activeCostGroup.costs.length">
        <div class="col-3">Min qty</div>
        <div class="col-3">Max qty</div>
        <div class="col-3">Price</div>
    </div>
    <div class="row mt-3" *ngIf="activeCostGroup && !activeCostGroup.costs.length">
        <p>Set your first price point by clicking the + icon below</p>
    </div>

    <ng-container *ngFor="let costGroup of costGroups; let cg = index">
        <ng-container *ngIf="activeCostGroup && (activeCostGroup.id === costGroup.id)">
            <div class="row mt-3" *ngFor="let cost of costGroup.costs; let idx = index">
                <div class="col-3">
                    <input [(ngModel)]="cost.minQty" (ngModelChange)="save()" type="number" class="form-control bordered mb-1" [placeholder]="'Min Qty'" />
                </div>
                <div class="col-3">
                    <input [(ngModel)]="cost.maxQty" (ngModelChange)="save()" type="number" class="form-control bordered mb-1" [placeholder]="'Max Qty'" />
                </div>
                <div class="col-5">
                    <input [(ngModel)]="cost.cost" (ngModelChange)="save()" type="number" class="form-control bordered mb-1" [placeholder]="'Price'" />
                </div>
                <div class="col-1">
                    <a (click)="remove(idx)">
                        <i class="fa fa-trash"></i>
                    </a>
                </div>
            </div>
            <div class="text-end mt-2 mb-3">
                <button type="button" class="btn btn-round btn-slim btn-primary" (click)="add()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>

        </ng-container>
    </ng-container>
</div>
